(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bp-collapse-text"] && !Shopify.designMode) return;
  try {
    /* Document-level delegation so multiple block instances on the
     same page all wire up automatically. Idempotent via the
     singleton flag. */
  if (!window.__bpCollapseWired) {
    window.__bpCollapseWired = true;
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-bp-collapse-trigger]');
      if (!trigger) return;
      const root = trigger.closest('[data-bp-collapse]');
      if (!root) return;
      const content = root.querySelector('[data-bp-collapse-content]');
      if (!content) return;
      const open = root.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', String(open));
      if (open) content.removeAttribute('hidden');
      else content.setAttribute('hidden', '');
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bp-complete-the-look"] && !Shopify.designMode) return;
  try {
    // Exact BP bag icon (matches snippets/bp-product-card.liquid .bp-card__quick).
  const BP_CTL_BAG_SVG = '<svg viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M4.18929 5.74434H16.5343H16.6292L16.6729 5.74549C16.9007 5.75099 17.1328 5.87803 17.2448 6.08089C17.3145 6.20157 17.3382 6.30372 17.3547 6.43048C17.6354 9.18806 17.9008 11.996 18.3051 14.7356C18.3771 15.2467 18.4466 15.758 18.5137 16.2697C18.5163 16.2917 18.5195 16.336 18.5207 16.3582C18.5378 16.6193 18.4156 16.9263 18.1508 17.0687C17.9651 17.1752 17.7807 17.1763 17.5845 17.1755C16.1978 17.1755 4.69428 17.1755 3.34023 17.1755C3.20422 17.1726 3.01496 17.1862 2.86505 17.1451C2.45036 17.0406 2.25213 16.656 2.31666 16.2445C2.41071 15.5271 2.58579 14.2489 2.68621 13.5185C2.95476 11.5399 3.15849 9.46674 3.35962 7.47459C3.37582 7.3571 3.44296 6.63739 3.45714 6.52887L3.46698 6.43424L3.46814 6.42237C3.46814 6.41948 3.46901 6.4134 3.47045 6.40559C3.5156 6.02417 3.79254 5.74028 4.18929 5.74434ZM4.18929 6.6125C4.2136 6.6125 4.24804 6.59601 4.27872 6.57343C4.30302 6.55491 4.3201 6.53089 4.32704 6.51845C4.33457 6.50601 4.33486 6.50138 4.33399 6.50427C4.33341 6.50803 4.33225 6.51353 4.33138 6.51758C4.33138 6.51758 4.33081 6.51932 4.33052 6.52424L4.32936 6.5361L4.31923 6.63044C4.132 8.4151 3.9054 10.3181 3.74624 12.1016C3.63685 13.4481 3.56103 15.0256 3.46727 16.3753L3.46582 16.3915V16.3961C3.46582 16.3961 3.46611 16.3973 3.4664 16.3915C3.4664 16.3872 3.4664 16.375 3.46351 16.3588C3.45396 16.2908 3.41721 16.2161 3.3602 16.1507C3.29306 16.0798 3.20422 16.0246 3.12319 16.0162C3.11856 16.0162 3.13361 16.0173 3.15647 16.0176C4.67199 16.0182 16.0117 16.0176 17.5848 16.0176H17.6719C17.6823 16.017 17.6916 16.0168 17.6962 16.0165C17.7014 16.0162 17.7034 16.0159 17.6991 16.0162C17.5752 16.0286 17.4268 16.1591 17.3857 16.2795C17.3576 16.3556 17.3617 16.3788 17.362 16.3941C17.362 16.3921 17.362 16.393 17.362 16.3886L17.3605 16.3724C17.254 14.8543 17.1872 13.3292 17.0509 11.8148C16.8906 10.0895 16.6752 8.23163 16.4883 6.50456C16.495 6.52019 16.5161 6.55433 16.5468 6.57575C16.5714 6.59485 16.5989 6.60585 16.6145 6.60961L16.6243 6.61192H16.6284C16.6284 6.61192 16.6298 6.61279 16.6304 6.61279C16.6318 6.61279 16.6336 6.61279 16.633 6.61279C16.6324 6.61279 16.635 6.61279 16.6292 6.61279C16.5783 6.61221 16.4 6.61337 16.3445 6.61279H4.18929V6.6125Z"/><path d="M6.08301 8.78064C6.1788 7.5189 6.20658 6.21405 6.58539 4.98907C7.15432 3.11007 8.4421 2.11631 10.414 2.12673C13.8001 2.13338 14.5031 4.87997 14.6721 7.71395C14.6964 8.07453 14.7158 8.43453 14.745 8.78035L13.5874 8.77485C13.6172 8.46057 13.6575 8.02649 13.6754 7.71858C13.801 5.83351 13.5976 3.34129 11.3988 2.81605C10.7575 2.6676 10.0702 2.6676 9.42892 2.81605C7.61503 3.24811 7.15143 5.0374 7.12683 6.6872C7.11121 7.36929 7.17545 8.09132 7.24056 8.77485L6.08301 8.78035V8.78064Z"/></svg>';

  class BpCtl extends HTMLElement {
    async connectedCallback() {
      this.style_ = this.dataset.bpCtlStyle || '';
      this.amplience = this.dataset.bpCtlAmplience || '';
      this.max = parseInt(this.dataset.bpCtlMax, 10) || 4;
      this.rail = this.querySelector('[data-bp-ctl-rail]');
      this.prev = this.querySelector('[data-bp-ctl-prev]');
      this.next = this.querySelector('[data-bp-ctl-next]');

      if (!this.style_ || !this.rail) return;

      // Defer the outfit fetch until the block is near the viewport — it's
      // below the fold in the PDP right column, so fetching at page load
      // competes with the LCP. bp-ctl starts `hidden` (display:none) and
      // IntersectionObserver can't observe a box-less element, so anchor a
      // 1px sentinel at its DOM position (always in layout) and observe
      // that instead. Once, ~600px lead.
      if ('IntersectionObserver' in window && this.parentNode) {
        const sentinel = document.createElement('div');
        sentinel.setAttribute('aria-hidden', 'true');
        sentinel.style.cssText = 'width:1px;height:1px;';
        this.parentNode.insertBefore(sentinel, this);
        const io = new IntersectionObserver((entries, obs) => {
          if (entries.some((e) => e.isIntersecting)) {
            obs.disconnect();
            sentinel.remove();
            this.load();
          }
        }, { rootMargin: '600px 0px' });
        io.observe(sentinel);
      } else {
        this.load();
      }
    }

    async load() {
      try {
        this.outfit_ = await this.fetchOutfit(this.style_);
        if (!this.outfit_ || !this.outfit_.items || !this.outfit_.items.length) return;
        this.paint();
        this.wireArrows();
        this.wireBags();

        // Re-filter whenever the bag changes — the customer can add an
        // item (from here, or the quick-add drawer) without leaving the
        // PDP, and it must drop out of these recommendations.
        //
        // `bp:cart-lines:rendered` is the load-bearing one: cart:updated
        // fires as soon as /cart/change.js returns, which is BEFORE the
        // drawer swaps in the lines that carry data-bp-style, so a paint
        // on that alone would read the pre-mutation bag. cart:updated is
        // kept as a cheap belt-and-braces — paint() is idempotent.
        this.onCart_ = () => this.paint();
        document.addEventListener('bp:cart-lines:rendered', this.onCart_);
        document.addEventListener('cart:updated', this.onCart_);
      } catch (err) {
        console.warn('[bp-ctl] outfit fetch failed', err);
      }
    }

    disconnectedCallback() {
      if (this._qaHost) { this._qaHost.remove(); this._qaHost = null; }
      if (!this.onCart_) return;
      document.removeEventListener('bp:cart-lines:rendered', this.onCart_);
      document.removeEventListener('cart:updated', this.onCart_);
    }

    // Every bp_style currently in the bag. bp-cart-line-item.liquid
    // stamps data-bp-style on each cart line and the drawer lives in the
    // topnav on every page, so the bag is readable here without a fetch
    // (/cart.js carries no metafields, so it can't answer this).
    cartStyles() {
      const out = new Set();
      document.querySelectorAll('[data-bp-cart-line][data-bp-style]').forEach((line) => {
        const s = (line.getAttribute('data-bp-style') || '').trim();
        if (s) out.add(String(s));
      });
      return out;
    }

    paint() {
      const inCart = this.cartStyles();
      const items = this.sortItems(this.style_, this.outfit_.items)
        .filter((it) => !(it && it.remote_id && inCart.has(String(it.remote_id))))
        .slice(0, this.max);
      // Everything in the outfit is already in the bag — nothing to
      // recommend, so hide rather than render an empty rail.
      if (!items.length) { this.hidden = true; return; }
      this.renderItems(items);
      this.hidden = false; // unhide once we have content
      this.updateArrowState();
    }

    async fetchOutfit(style) {
      // Prefer the shared, memoized fetch (bp-stylitics-loader) so the PDP
      // makes ONE outfits request that this block, the HTWI jumplink, and
      // HTWI tracking all reuse — instead of each hitting the endpoint.
      // Falls back to a direct fetch if the helper isn't present.
      let data;
      if (typeof window.bpStyliticsOutfits === 'function') {
        data = await window.bpStyliticsOutfits(style);
      } else {
        const url = `https://widget-api.stylitics.com/api/outfits?username=bostonproper&item_number=${encodeURIComponent(style)}`;
        const res = await fetch(url, { cache: 'force-cache' });
        if (!res.ok) throw new Error('outfits HTTP ' + res.status);
        data = await res.json();
      }
      // Atlas's response is an array of outfits — take the first.
      return Array.isArray(data) && data.length ? data[0] : null;
    }

    // sortOutfitItems from Atlas — pulls the anchor (current product)
    // out of the list so it isn't shown again.
    sortItems(style, items) {
      const list = Array.from(items || []);
      const idx = list.findIndex((it) => it && it.remote_id === style);
      if (idx >= 0) list.splice(idx, 1);
      return list;
    }

    renderItems(items) {
      const html = items.map((item) => {
        const name = (item && item.name) || '';
        const isCollective = item && item.brand !== 'Boston Proper';
        const remoteId = item && item.remote_id;
        const fallback = (item && item.image_url) || '';
        const imageUrl = (isCollective || !remoteId)
          ? fallback
          : `${this.amplience}/i/bostonproper/${remoteId}_2?fmt=auto&w=800`;
        const rawLink = (item && item.affiliate_link) || '';
        const url = rawLink.replace(/^https?:\/\/(?:www\.)?bostonproper\.com/, '');
        return `
          <li class="bp-ctl__item">
            <a class="bp-ctl__link" href="${url}">
              <div class="bp-ctl__media">
                <img src="${imageUrl}" alt="${this.escape(name)}" width="400" height="500" loading="lazy">
                <button type="button" class="bp-ctl__bag" data-bp-ctl-bag data-url="${url}" data-bp-remote-id="${this.escape(String(remoteId == null ? '' : remoteId))}" aria-label="Quick add ${this.escape(name)}">${BP_CTL_BAG_SVG}</button>
              </div>
              <p class="bp-ctl__name">${this.escape(name)}</p>
            </a>
          </li>`;
      }).join('');
      this.rail.innerHTML = html;
    }

    escape(s) {
      return String(s || '').replace(/[&<>"']/g, (c) => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
      }[c]));
    }

    // Bag button → quick-add drawer for that product. Delegated on the rail
    // (bound once; survives paint() re-renders). preventDefault blocks the
    // parent <a>'s PDP navigation so only the bag opens the drawer.
    wireBags() {
      if (this._bagsBound) return;
      this._bagsBound = true;
      this.rail.addEventListener('click', (e) => {
        const bag = e.target.closest && e.target.closest('[data-bp-ctl-bag]');
        if (!bag) return;
        e.preventDefault();
        e.stopPropagation();
        const url = bag.getAttribute('data-url');
        // Stylitics ATC engagement (Atlas parity): flag this widget quick-add
        // so bp-how-to-wear-it's global cart-diff attributes the follow-up
        // /cart/add as a 'widget' engagement and fires ONE trackAddItemToCart
        // beacon. Without this the add succeeds but no engagement is emitted.
        this.setStyliticsWidgetAddContext(url, bag.getAttribute('data-bp-remote-id'));
        this.openQuickAdd(url);
      });
    }

    // Publish the window.__bpStyliticsWidgetAdd contract that
    // bp-how-to-wear-it (the single Stylitics ATC tracker on the PDP) reads
    // in its cart-diff: the next /cart/add whose line handle matches is
    // reported to Stylitics as placement 'widget' with this itemId. itemId is
    // the outfit item's Stylitics remote_id (Atlas passes the product style,
    // which is the same identifier); falls back to the handle if absent.
    setStyliticsWidgetAddContext(url, remoteId) {
      const handle = (String(url || '').match(/\/products\/([^/?#]+)/) || [])[1] || '';
      if (!handle) return;
      window.__bpStyliticsWidgetAdd = {
        style: String(remoteId || handle),
        handle: handle,
        until: Date.now() + 90000,
      };
    }

    // Open Lana's quick-add drawer for a product URL. Horizon derives the URL
    // from a <product-card> ancestor's ref="productCardLink"; build a hidden
    // minimal trigger and open the drawer via window.bpOpenProductDrawer.
    openQuickAdd(productUrl) {
      if (!productUrl) return;
      let host = this._qaHost;
      if (!host) {
        host = document.createElement('div');
        host.style.cssText = 'position:absolute;left:-9999px;top:0;width:1px;height:1px;overflow:hidden;';
        document.body.appendChild(host);
        this._qaHost = host;
      }
      host.innerHTML =
        '<product-card>' +
        '<a class="product-card__link" ref="productCardLink" href="' + productUrl + '"></a>' +
        '<quick-add-component ref="quickAdd">' +
        '<button type="button" class="button quick-add__button quick-add__button--choose add-to-cart-button" ' +
        'on:click="quick-add-component/handleClick"></button>' +
        '</quick-add-component>' +
        '</product-card>';
      const choose = host.querySelector('.quick-add__button--choose');
      // Cart Quickview view_item (GA4 QA #2) — this bespoke trigger isn't a
      // .bp-card, so bp-track-cards' fireQuickview can't see it.
      if (typeof window.bpTrackCartQuickview === 'function') window.bpTrackCartQuickview(productUrl);
      requestAnimationFrame(() => {
        try {
          if (typeof window.bpOpenProductDrawer === 'function' && choose) window.bpOpenProductDrawer(choose);
          else if (choose) choose.click();
          else window.location.href = productUrl;
        } catch (err) {
          console.warn('[bp-ctl] quick-add open failed, navigating', err);
          window.location.href = productUrl;
        }
      });
    }

    wireArrows() {
      if (this.prev) {
        this.prev.addEventListener('click', () => {
          this.rail.scrollBy({ left: -this.rail.clientWidth, behavior: 'smooth' });
        });
      }
      if (this.next) {
        this.next.addEventListener('click', () => {
          this.rail.scrollBy({ left: this.rail.clientWidth, behavior: 'smooth' });
        });
      }
      this.rail.addEventListener('scroll', () => this.updateArrowState(), { passive: true });
    }

    updateArrowState() {
      const max = this.rail.scrollWidth - this.rail.clientWidth;
      if (this.prev) this.prev.toggleAttribute('disabled', this.rail.scrollLeft <= 1);
      if (this.next) this.next.toggleAttribute('disabled', this.rail.scrollLeft >= max - 1);
    }
  }
  if (!customElements.get('bp-ctl')) customElements.define('bp-ctl', BpCtl);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bp-pdp-bundle"] && !Shopify.designMode) return;
  try {
    class BpPdpBundle extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-bp-bundle-card]').forEach((card) => this.wireCard(card));
    }

    wireCard(card) {
      const select = card.querySelector('[data-bp-bundle-card-variant-select]');
      if (!select) return;
      this.wireOptionValues(card);
      // Colour swatch → swap the card to that colourway INLINE (no navigation).
      card.querySelectorAll('[data-bp-bundle-swatch]').forEach((sw) => {
        sw.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.swapColor(card, sw);
        });
      });
      const addBtn = card.querySelector('[data-bp-bundle-card-add]');
      if (addBtn) addBtn.addEventListener('click', () => this.addCard(card));
      const clearBtn = card.querySelector('[data-bp-bundle-card-clear]');
      if (clearBtn) clearBtn.addEventListener('click', () => this.clearCard(card));
      this.onOptionChange(card); // reflect any preselected colour
    }

    // Wire the size option-values (radios + label clicks). Guarded so a
    // re-render (colour swap rebuilds the size fieldset) doesn't double-bind.
    wireOptionValues(card) {
      card.querySelectorAll('.bp-bundle-card__option-value input[type="radio"]').forEach((r) => {
        if (r.dataset.bpWired === '1') return;
        r.dataset.bpWired = '1';
        r.addEventListener('change', () => this.onOptionChange(card));
      });
      card.querySelectorAll('.bp-bundle-card__option-value').forEach((label) => {
        if (label.dataset.bpWired === '1') return;
        label.dataset.bpWired = '1';
        label.addEventListener('click', () => {
          const input = label.querySelector('input[type="radio"]');
          if (input && !input.disabled && !input.checked) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
        });
      });
    }

    // Swap this card to the clicked colourway inline: fetch the sibling
    // product's JSON, then re-point the image, title, colour label, sizes,
    // hidden <select>, and the card's product handle/id — without leaving the
    // page. Falls back to navigation if the fetch fails.
    async swapColor(card, el) {
      if (el.classList.contains('is-selected')) return; // already this colour
      const handle = el.getAttribute('data-bp-bundle-swatch-handle') || '';
      const href = el.getAttribute('href') || ('/products/' + handle);
      if (!handle) { if (el.tagName === 'A') window.location.href = href; return; }
      if (card.dataset.bpSwapping === '1') return;
      card.dataset.bpSwapping = '1';
      card.classList.add('is-swapping');
      try {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const base = root.replace(/\/$/, '');
        const res = await fetch(base + '/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const data = await res.json();
        this.applySwap(card, el, data);
      } catch (err) {
        console.warn('[bp-pdp-bundle] colour swap failed, navigating', err);
        window.location.href = href;
      } finally {
        card.dataset.bpSwapping = '';
        card.classList.remove('is-swapping');
      }
    }

    applySwap(card, el, data) {
      const esc = (v) => String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
      const colorName = el.getAttribute('aria-label') || '';
      const variants = data.variants || [];

      // Which option index is size (the non-colour one).
      const optNames = (data.options || []).map((o) => (typeof o === 'string' ? o : (o && o.name) || ''));
      let colorIdx = optNames.findIndex((n) => /colou?r/i.test(n));
      if (colorIdx < 0) colorIdx = 0;
      let sizeIdx = optNames.findIndex((n, i) => i !== colorIdx);
      if (sizeIdx < 0) sizeIdx = optNames.length > 1 ? 1 : 0;
      const sizeKey = 'option' + (sizeIdx + 1);
      const sizeName = optNames[sizeIdx] || 'Size';

      // Image.
      const img = card.querySelector('.bp-bundle-card__img');
      if (img && data.featured_image) {
        const raw = String(data.featured_image);
        const noProto = raw.indexOf('//') === 0 ? raw : raw.replace(/^https?:/, '');
        const cut = noProto.split('?')[0];
        const ver = (raw.match(/[?&]v=(\d+)/) || [])[1];
        const sized = (w) => cut + '?width=' + w + (ver ? '&v=' + ver : '');
        img.src = sized(600);
        img.srcset = sized(300) + ' 300w, ' + sized(600) + ' 600w, ' + sized(900) + ' 900w';
        img.alt = data.title || '';
        img.removeAttribute('width'); img.removeAttribute('height');
      }

      // Title + colour label.
      const titleEl = card.querySelector('.bp-bundle-card__title');
      if (titleEl && data.title) titleEl.textContent = data.title;
      const activeColor = card.querySelector('[data-bp-active-color]');
      if (activeColor && colorName) activeColor.textContent = colorName;

      // Selected swatch.
      card.querySelectorAll('[data-bp-bundle-swatch]').forEach((sw) => {
        sw.classList.toggle('is-selected', sw === el);
      });

      // Rebuild sizes (nothing pre-selected — bundle items require an active
      // size choice, same as the initial render).
      const sizeFs = card.querySelector('fieldset[data-option-position]:not(.bp-bundle-card__option--color)');
      if (sizeFs) {
        const avail = {};
        const order = [];
        variants.forEach((v) => {
          const sv = v[sizeKey];
          if (sv == null) return;
          if (!(sv in avail)) { avail[sv] = false; order.push(sv); }
          if (v.available) avail[sv] = true;
        });
        const wrap = sizeFs.querySelector('.bp-bundle-card__option-values');
        if (wrap) {
          wrap.innerHTML = order.map((sv) => {
            const un = avail[sv] ? '' : ' is-unavailable';
            return '<label class="bp-bundle-card__option-value' + un + '" data-value="' + esc(sv) + '" aria-label="' + esc(sv) + '" title="' + esc(sv) + '">' +
              '<input type="radio" name="options[' + esc(sizeName) + ']" value="' + esc(sv) + '"' + (avail[sv] ? '' : ' disabled') + '>' +
              '<span class="bp-bundle-card__option-text">' + esc(sv) + '</span></label>';
          }).join('');
        }
        const span = sizeFs.querySelector('[data-bp-bundle-card-option-value]');
        if (span) span.textContent = '';
        const clr = sizeFs.querySelector('[data-bp-bundle-card-clear]');
        if (clr) clr.hidden = true;
      }

      // Rebuild the hidden variant <select> for the new colourway.
      const select = card.querySelector('[data-bp-bundle-card-variant-select]');
      if (select) {
        select.innerHTML = variants.map((v) =>
          '<option value="' + v.id + '" data-price="' + v.price + '" data-available="' + v.available + '"' +
          ' data-option1="' + esc(v.option1 || '') + '" data-option2="' + esc(v.option2 || '') + '" data-option3="' + esc(v.option3 || '') + '">' +
          esc(v.title || '') + '</option>'
        ).join('');
      }

      // Re-point the card so Add to Bag adds the new colourway + its LIPs.
      card.dataset.productId = String(data.id || '');
      card.dataset.productHandle = data.handle || '';

      this.wireOptionValues(card);
      this.onOptionChange(card);
    }

    onOptionChange(card) {
      card.querySelectorAll('.bp-bundle-card__option-value').forEach((l) => {
        const i = l.querySelector('input[type="radio"]');
        l.classList.toggle('is-selected', !!(i && i.checked));
      });

      const picked = [null, null, null];
      let allPicked = true;
      let sizeValue = '';
      card.querySelectorAll('fieldset[data-option-position]').forEach((fs) => {
        const pos = parseInt(fs.dataset.optionPosition, 10);
        const checked = fs.querySelector('input[type="radio"]:checked');
        if (checked) {
          picked[pos - 1] = checked.value;
          if (!fs.classList.contains('bp-bundle-card__option--color')) sizeValue = checked.value;
        } else {
          allPicked = false;
        }
      });

      const select = card.querySelector('[data-bp-bundle-card-variant-select]');
      let matched = null;
      Array.from(select.options).forEach((opt) => {
        if ((picked[0] === null || opt.dataset.option1 === picked[0]) &&
            (picked[1] === null || opt.dataset.option2 === picked[1]) &&
            (picked[2] === null || opt.dataset.option3 === picked[2])) {
          if (!matched) matched = opt;
        }
      });
      if (matched) select.value = matched.value;
      const available = !!(matched && matched.dataset.available === 'true');
      const ready = allPicked && available;

      const addBtn = card.querySelector('[data-bp-bundle-card-add]');
      const addLabel = card.querySelector('[data-bp-bundle-card-add-label]');
      if (addBtn) addBtn.disabled = !ready;
      if (addLabel) addLabel.textContent = ready ? 'ADD TO BAG' : (allPicked ? 'Unavailable' : 'Add to Bag');

      // Size legend shows the picked size + reveal Clear.
      const sizeFs = card.querySelector('fieldset[data-option-position]:not(.bp-bundle-card__option--color)');
      if (sizeFs) {
        const span = sizeFs.querySelector('[data-bp-bundle-card-option-value]');
        if (span) span.textContent = sizeValue;
        const clr = sizeFs.querySelector('[data-bp-bundle-card-clear]');
        if (clr) clr.hidden = !sizeValue;
      }
    }

    clearCard(card) {
      card.querySelectorAll('fieldset[data-option-position]:not(.bp-bundle-card__option--color) input[type="radio"]').forEach((r) => { r.checked = false; });
      this.onOptionChange(card);
    }

    async addCard(card) {
      const select = card.querySelector('[data-bp-bundle-card-variant-select]');
      const id = select && select.value;
      if (!id) return;
      const handle = card.dataset.productHandle;
      const item = { id: Number(id), quantity: 1 };
      try {
        if (window.bpLips && handle) {
          const props = await window.bpLips.forVariant(handle, id);
          if (props && Object.keys(props).length) item.properties = props;
        }
      } catch (_) { /* add without props */ }

      const addBtn = card.querySelector('[data-bp-bundle-card-add]');
      if (addBtn) addBtn.disabled = true;
      try {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [item] }) });
        if (!res.ok) throw new Error('cart/add HTTP ' + res.status);
        const data = await res.json();
        document.dispatchEvent(new CustomEvent('product:added', { detail: { items: data && data.items && data.items[0], triggerArea: 'other' } }));
        if (window.bpOpenCartDrawer) window.bpOpenCartDrawer();
      } catch (err) {
        console.error('[bp-pdp-bundle] add failed', err);
      } finally {
        if (addBtn) addBtn.disabled = false;
      }
    }
  }
  if (!customElements.get('bp-pdp-bundle')) {
    customElements.define('bp-pdp-bundle', BpPdpBundle);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bp-pdp-media-gallery"] && !Shopify.designMode) return;
  try {
    class BpPdpGallery extends HTMLElement {
    async connectedCallback() {
      this.rail = this.querySelector('[data-bp-pdp-rail]');
      this.indicator = this.querySelector('[data-bp-pdp-indicator]');
      this.dots = this.querySelector('[data-bp-pdp-dots]');
      this.style_ = this.dataset.bpStyle || '';
      this.amplienceBase = this.dataset.bpAmplienceBase || '';
      this.max = parseInt(this.dataset.bpMaxItems, 10) || 6;
      this.productTitle = this.dataset.bpProductTitle || '';

      // Desktop sticky pin (QA: Adrienne). CSS position:sticky never engaged
      // reliably in Horizon's product grid across environments, so pin in JS —
      // but SMOOTHLY (see initStickyPin): `position: fixed` with a constant top
      // in the sticky zone, so the browser holds it natively (no per-frame
      // movement, unlike the old translateY pin).
      this.initStickyPin();

      // Hide the "How to Wear It" jumplink when this product has no published
      // Stylitics outfits (QA: Pearl & Jewel sweater — the widget correctly
      // hid itself, but the jumplink lingered over nothing). Gate on the
      // shared, memoized outfits fetch (bp-stylitics-loader) — the SAME call
      // the widget + Complete-the-look reuse, so this adds no network request.
      // Fail-safe: with no helper we leave the server-rendered pill visible;
      // an empty/failed fetch hides it (Atlas parity — jumplink renders only
      // when there are outfits). Runs per gallery instance, so a colour
      // soft-swap (new bp-pdp-gallery) re-evaluates for the new style.
      var _htwiJump = this.querySelector('[data-bp-gallery-htwi]');
      if (_htwiJump && this.style_ && typeof window.bpStyliticsOutfits === 'function') {
        _htwiJump.hidden = true;
        window.bpStyliticsOutfits(this.style_)
          .then(function (outfits) { _htwiJump.hidden = !(outfits && outfits.length); })
          .catch(function () { _htwiJump.hidden = false; });
      }

      // Amplience is authoritative for bp_style products. Slide 0 (the
      // deterministic {style}_1 hero) is already server-painted; the
      // _SET.json manifest gives us the rest of the set (variable count,
      // incl. videos). On success replaceRail() rebuilds ONLY slides 1..n
      // and keeps slide 0 (no re-fetch of the visible image → no flicker).
      // On failure/empty we hydrate slides 1..n from the inert Shopify
      // <template> so zoom/thumbnails still get the full set.
      const hasPrimary = !!(this.rail && this.rail.querySelector('[data-bp-amp-primary]'));
      if (this.style_ && this.amplienceBase) {
        try {
          const items = await this.fetchAmplience(this.style_);
          if (Array.isArray(items) && items.length > 0) {
            this.replaceRail(items.slice(0, this.max));
          } else if (hasPrimary) {
            this.hydrateFromFallback();
          }
        } catch (err) {
          // swallow — hydrate slides 1..n from the Shopify <template>
          // (slide 0 stays as the painted _1 hero).
          console.warn('[bp-pdp-gallery] amplience fetch failed', err);
          if (hasPrimary) this.hydrateFromFallback();
        }
      }

      this.wireIndicator();
      this.wireDots();
    }

    // Smooth desktop sticky pin. Instead of moving the gallery every frame
    // (the old translateY pin — janky), we fix it with a CONSTANT top while in
    // the sticky zone, so the browser keeps it fixed natively (composited, no
    // per-frame JS movement). JS only recomputes state at the thresholds.
    //
    // Three states down the page:
    //   top    → before the pin engages: normal flow (position cleared).
    //   fixed  → in the zone: position:fixed; top:OFFSET; left/width matched to
    //            the media column. The gallery visually holds still while the
    //            form scrolls — perfectly smooth.
    //   bottom → past the zone: position:absolute at the column bottom, so it
    //            releases and scrolls away with the page (no overlap below).
    //
    // Travel distance is measured from the DETAILS column (never pinned), not
    // the media column — once the gallery goes out of flow the media column
    // collapses, so measuring it would thrash. `align-items:start` keeps the
    // grid row height held by the details column, so fixing the gallery never
    // makes the layout jump. Desktop only; mobile is the carousel.
    initStickyPin() {
      const gallery = this;
      const col = gallery.closest('.product-information__media');
      if (!col) return;
      const details =
        (col.parentElement && col.parentElement.querySelector('.product-details')) || null;
      const OFFSET = 96; // clears the sticky header
      const mq = window.matchMedia('(min-width: 1024px)');
      let state = '';
      let ticking = false;
      // The gallery's EXACT in-flow geometry, captured while it's not pinned.
      // Reused verbatim for the fixed state so the pinned gallery is the same
      // width + x-position as in flow (measuring the COLUMN instead drifted a
      // few px wider — column padding / the gallery not filling the column edge
      // to edge). left is viewport-relative (valid for position:fixed) and
      // constant on vertical scroll; refreshed here + on resize.
      let flowLeft = 0;
      let flowWidth = 0;

      const reset = () => {
        gallery.style.position = '';
        gallery.style.top = '';
        gallery.style.left = '';
        gallery.style.width = '';
        state = 'top';
      };

      const apply = () => {
        ticking = false;
        if (!mq.matches) { if (state) reset(); return; }

        // Column must be a positioning context for the 'bottom' (absolute) state.
        if (getComputedStyle(col).position === 'static') col.style.position = 'relative';

        // Capture the gallery's real in-flow box ONLY while it's in normal
        // flow ('top' / initial). Do NOT capture in 'bottom': there the gallery
        // is position:absolute with width:auto, so it shrinks to content width
        // — capturing then fed a too-narrow width into the next 'fixed' pass,
        // which is the horizontal flick on scroll (QA: Adrienne). The 'top'
        // measurement is the single source of truth for the fixed geometry.
        if (state === '' || state === 'top') {
          const gr = gallery.getBoundingClientRect();
          flowLeft = gr.left;
          flowWidth = gr.width;
        }

        // Only pin genuinely SHORT galleries — ≤ 2 images, i.e. a single
        // desktop grid row (QA: Adrienne). With more images the gallery is
        // tall (≈ the details column), so the JS fixed-movement buys almost
        // nothing and its marginal travel is what makes scrolling feel glitchy.
        // Count real slides, excluding the async Amplience placeholders; the
        // count settles after replaceRail (apply re-runs at 300/1200ms + on
        // scroll), so a product that hydrates >2 images self-releases.
        const slideCount = gallery.querySelectorAll(
          '.bp-pdp-gallery__slide:not([data-bp-amp-placeholder])'
        ).length;
        if (slideCount > 2) { if (state && state !== 'top') reset(); return; }

        const colRect = col.getBoundingClientRect();
        const colTopDoc = window.scrollY + colRect.top; // row top in document coords
        const galleryH = gallery.offsetHeight;          // stable even when fixed
        const refH = details ? details.offsetHeight : col.offsetHeight;
        const travel = refH - galleryH;                 // how far the gallery can pin down

        if (travel <= 4) { if (state && state !== 'top') reset(); return; } // gallery is the tall column → just scroll

        const start = colTopDoc - OFFSET;
        const end = start + travel;
        const y = window.scrollY;

        if (y <= start) {
          if (state !== 'top') reset();
        } else if (y >= end) {
          // Park at the column bottom so it releases with the page. Keep the
          // SAME captured width as the fixed state — an absolute box with no
          // width shrinks to content width, so clearing it here made the
          // gallery visibly narrow (flick) at the fixed→bottom boundary
          // (QA: Adrienne). left:0 is column-relative (the column is the
          // positioning context) so the x still lines up.
          if (state !== 'bottom') {
            gallery.style.position = 'absolute';
            gallery.style.top = travel + 'px';
            gallery.style.left = '0';
            gallery.style.width = flowWidth + 'px';
            state = 'bottom';
          }
        } else {
          // Fixed zone — constant top → native-smooth. Use the captured in-flow
          // left/width so the pinned gallery is identical in size + position to
          // its flow state (no widening toward the right column).
          gallery.style.position = 'fixed';
          gallery.style.top = OFFSET + 'px';
          gallery.style.left = flowLeft + 'px';
          gallery.style.width = flowWidth + 'px';
          state = 'fixed';
        }
      };

      const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(apply); } };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      if (mq.addEventListener) mq.addEventListener('change', () => { reset(); onScroll(); });
      // Re-measure after images/Amplience settle (heights change the travel).
      setTimeout(apply, 300);
      setTimeout(apply, 1200);
      apply();
    }

    async fetchAmplience(style) {
      // Atlas's URL pattern: {base}/s/bostonproper/{style}_SET.json?protocol=https
      const url = `${this.amplienceBase}/s/bostonproper/${encodeURIComponent(style)}_SET.json?protocol=https`;
      const res = await fetch(url, { credentials: 'omit' });
      if (!res.ok) throw new Error('Amplience HTTP ' + res.status);
      const data = await res.json();
      return data && data.items;
    }

    replaceRail(items) {
      if (!this.rail) return;
      const primary = this.rail.querySelector('[data-bp-amp-primary]');
      // Slide 0 was server-painted as {style}_1 on the ASSUMPTION it equals
      // the manifest's items[0]. True for clothing; FALSE for accessories /
      // shoes / jewelry, where _1 doesn't exist — Amplience serves a "coming
      // soon" placeholder with a 200 (so the <img> onerror never fires) and
      // the real set starts at items[0] (e.g. _2), which the _SET.json manifest
      // omits _1 from entirely. Keeping slide 0 there left the coming-soon
      // visible AND dropped items[0] via slice(1) below (QA 7/27, Brooke).
      // Compare the manifest's first URL to the painted one (ignoring ?w=
      // sizing): match → keep slide 0 (no flicker); mismatch → rebuild the
      // whole rail from items[0..n] so items[0] is the visible first image.
      // Slide 0 is now server-painted as _SET/1 (the SET's first asset), which
      // is always items[0] — so keep it whenever it exists (no re-fetch /
      // flicker) and rebuild only slides 1..n. (Previously slide 0 was the
      // individual _1, which mismatched items[0] on accessories/shoes and
      // forced a full-rail rebuild.)
      const keepSlide0 = !!(primary && items.length);
      if (primary && keepSlide0) {
        // items[0] === the painted _1 — keep slide 0 (no re-fetch of the
        // visible image, no flicker); rebuild ONLY slides 1..n.
        const slide0 = primary.closest('.bp-pdp-gallery__slide');
        let sib = slide0.nextElementSibling;
        while (sib) { const next = sib.nextElementSibling; sib.remove(); sib = next; }
        const rest = items.slice(1).map((item, i) => this.renderSlide(item, i + 1)).join('');
        if (rest) slide0.insertAdjacentHTML('afterend', rest);
      } else {
        // No pre-rendered slide 0, OR the painted _1 is the wrong image
        // (accessories/shoes coming-soon) — rebuild the whole rail from
        // items[0..n] so items[0] becomes the visible first image.
        this.rail.innerHTML = items.map((item, i) => this.renderSlide(item, i)).join('');
      }
      this.slides = Array.from(this.querySelectorAll('.bp-pdp-gallery__slide'));
      if (this.indicator) {
        if (items.length <= 1) {
          this.indicator.remove();
          this.indicator = null;
        } else if (this._updateIndicator) {
          requestAnimationFrame(this._updateIndicator);
        }
      }
      this.setAttribute('data-bp-source', 'amplience');
      this.setAttribute('data-bp-rendered-count', String(items.length));
    }

    // Amplience fetch failed/empty: keep the painted _1 hero (slide 0) and
    // fill slides 1..n by cloning the inert Shopify <template>, so zoom +
    // thumbnails have the full media set. Clears the reserved placeholders
    // first.
    hydrateFromFallback() {
      if (!this.rail) return;
      const primary = this.rail.querySelector('[data-bp-amp-primary]');
      const tpl = this.querySelector('template[data-bp-shopify-fallback]');
      if (!primary || !tpl) return;
      const slide0 = primary.closest('.bp-pdp-gallery__slide');
      let sib = slide0.nextElementSibling;
      while (sib) { const next = sib.nextElementSibling; sib.remove(); sib = next; }
      const frag = tpl.content.cloneNode(true);
      // Skip the template's own slide 0 — slide0 above already shows _1.
      frag.querySelectorAll('.bp-pdp-gallery__slide').forEach((s) => {
        if (s.getAttribute('data-index') === '0') return;
        this.rail.appendChild(s);
      });
      this.slides = Array.from(this.querySelectorAll('.bp-pdp-gallery__slide'));
      this.setAttribute('data-bp-source', 'shopify-fallback');
    }

    renderSlide(item, index) {
      const src = item && item.src ? item.src : '';
      const isVideo = item && item.type === 'video';
      const alt = `${this.productTitle} - ${index + 1}`.replace(/"/g, '&quot;');
      if (isVideo) {
        return `
          <div class="bp-pdp-gallery__slide" data-index="${index}" data-media-type="video">
            <div class="product-media">
              <video
                class="bp-pdp-gallery__video"
                controls
                autoplay
                playsinline
                muted
                loop
                preload="auto"
                poster="${src}"
              >
                <source src="${src}/mp4_720p" type="video/mp4">
                <source src="${src}/webm_720p" type="video/webm">
                <source src="${src}/mp4_480p" type="video/mp4">
              </video>
            </div>
          </div>`;
      }
      // Images: use the SET service by INDEX (_SET/{n}) rather than the
      // manifest's individual /i/{style}_N src — the SET's nth asset always
      // resolves even when there's no _1 (accessories/shoes). Slide data-index
      // is 0-based, SET index is 1-based, so it's index + 1.
      const setSrc = `${this.amplienceBase}/s/bostonproper/${encodeURIComponent(this.style_)}_SET/${index + 1}`;
      const base = `${setSrc}?w=1400&fmt=auto`;
      const srcset = [400, 800, 1200, 1600, 1920, 2560]
        .map((w) => `${setSrc}?w=${w}&fmt=auto ${w}w`)
        .join(', ');
      return `
        <div class="bp-pdp-gallery__slide" data-index="${index}" data-media-type="image">
          <div class="product-media">
            <img
              class="bp-pdp-gallery__img product-media__image"
              data-bp-zoomable
              data-bp-zoom-index="${index}"
              src="${base}"
              srcset="${srcset}"
              sizes="(min-width: 1024px) calc(50vw - 60px), 100vw"
              alt="${alt}"
              loading="${index === 0 ? 'eager' : 'lazy'}"
              fetchpriority="${index === 0 ? 'high' : 'auto'}"
            >
          </div>
        </div>`;
    }

    wireIndicator() {
      if (!this.rail || !this.indicator) return;
      const update = () => {
        if (!this.rail || !this.indicator) return;
        const visible = this.rail.clientWidth;
        const total = this.rail.scrollWidth;
        if (total <= visible + 1) {
          this.indicator.style.display = 'none';
          return;
        }
        this.indicator.style.display = '';
        const overflow = total - visible;
        const thumbW = (visible / total) * 100;
        const thumbX = overflow > 0 ? this.rail.scrollLeft / overflow : 0;
        this.indicator.style.setProperty('--bp-pdp-thumb-w', thumbW + '%');
        this.indicator.style.setProperty('--bp-pdp-thumb-x', thumbX);
      };
      this._updateIndicator = update;
      this.rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      requestAnimationFrame(update);
    }

    // Quick-view dots (data-bp-quickview). Runs after wireIndicator, so
    // the rail's slides are already final (Amplience rebuild happened in
    // connectedCallback before this). One clickable dot per slide; the
    // active dot tracks the slide nearest the rail's centre as it scrolls.
    wireDots() {
      if (!this.rail || !this.dots) return;
      const slides = () => Array.from(this.querySelectorAll('.bp-pdp-gallery__slide'));

      const sync = () => {
        const list = slides();
        if (!list.length || !this.dots.children.length) return;
        const center = this.rail.scrollLeft + this.rail.clientWidth / 2;
        let active = 0;
        let best = Infinity;
        list.forEach((s, i) => {
          const c = s.offsetLeft - this.rail.offsetLeft + s.clientWidth / 2;
          const d = Math.abs(c - center);
          if (d < best) { best = d; active = i; }
        });
        Array.from(this.dots.children).forEach((dot, i) => {
          dot.classList.toggle('is-active', i === active);
          dot.setAttribute('aria-current', i === active ? 'true' : 'false');
        });
      };

      const build = () => {
        const list = slides();
        if (list.length <= 1) {
          this.dots.style.display = 'none';
          this.dots.innerHTML = '';
          return;
        }
        this.dots.style.display = '';
        if (this.dots.children.length !== list.length) {
          this.dots.innerHTML = list
            .map((_, i) => `<button type="button" class="bp-pdp-gallery__dot" aria-label="View image ${i + 1}"></button>`)
            .join('');
          Array.from(this.dots.children).forEach((dot, i) => {
            dot.addEventListener('click', () => {
              const s = slides()[i];
              if (!s) return;
              this.rail.scrollTo({ left: s.offsetLeft - this.rail.offsetLeft, behavior: 'smooth' });
            });
          });
        }
        sync();
      };

      this._buildDots = build;
      this._syncDots = sync;
      this.rail.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      build();
    }
  }
  if (!customElements.get('bp-pdp-gallery')) {
    customElements.define('bp-pdp-gallery', BpPdpGallery);
  }

  /* ===========================================================
     Wishlist icon — Swym + localStorage toggle. Ported from the
     retired bp-pdp-save-for-later block (without the reparent IIFE
     since placement is fixed inside the gallery now). Bound once
     per product id; idempotent on re-renders via the
     `_bpWishlistWired` flag.
     =========================================================== */
  (function () {
    /* DELEGATED on document (registered once), not wired per-heart. The old
       per-element version set `_bpWishlistWired = true` BEFORE checking for
       the JSON data, so if the heart was re-rendered (bp-pdp-swap color
       swap / Amplience replaceRail hydration) or the JSON wasn't in the DOM
       yet, the flag stuck true and it never retried — the overlay heart
       silently did nothing (staging hydration timing, Ernie 7/22). Delegation
       resolves the product/variant + reads the JSON fresh at CLICK time, so
       it's immune to re-renders and render order — same pattern the HTWI
       pill below already uses for the same reason. */
    if (!window.__bpPdpWishlistDelegated) {
      window.__bpPdpWishlistDelegated = true;

      var bpwGetData = function (productId) {
        var el = document.getElementById('bp-pdp-save-data-' + productId);
        if (!el) return null;
        try { return JSON.parse(el.textContent || '{}'); } catch (e) { return null; }
      };
      var bpwVariantId = function (data) {
        var idInput = document.querySelector('input[ref="variantId"], #quick-add-modal-content input[name="id"]');
        if (idInput && idInput.value) return String(idInput.value);
        return (data && data.variants && Object.keys(data.variants)[0]) || '';
      };
      var bpwIsSaved = function (vid) {
        try {
          if (!window.bpSavedForLater || !vid) return false;
          var list = window.bpSavedForLater.getLocalWishlist();
          return (list && list.items || []).some(function (it) {
            return String(it.variant_id) === String(vid);
          });
        } catch (_) { return false; }
      };
      // Reflect saved state on every heart currently in the DOM. Re-runnable,
      // so a heart re-rendered by replaceRail / a color swap shows the right
      // state without needing to be re-wired.
      var bpwRenderAll = function () {
        document.querySelectorAll('[data-bp-pdp-save-later]').forEach(function (root) {
          var btn = root.querySelector('[data-bp-pdp-save-later-btn]');
          if (!btn) return;
          var data = bpwGetData(root.getAttribute('data-product-id'));
          var saved = bpwIsSaved(bpwVariantId(data));
          root.classList.toggle('is-saved', saved);
          btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
          btn.setAttribute('aria-label', saved ? 'Remove from Wishlist' : 'Add to Wishlist');
        });
      };
      bpwRenderAll();
      ['wishlist:updated', 'bp:saved:updated', 'wishlist:item-saved',
       'variant:update', 'variant:change', 'bp:pdp:swapped'].forEach(function (ev) {
        document.addEventListener(ev, bpwRenderAll);
      });

      document.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('[data-bp-pdp-save-later-btn]');
        if (!btn) return;
        var root = btn.closest('[data-bp-pdp-save-later]');
        if (!root) return;
        e.preventDefault();

        var data = bpwGetData(root.getAttribute('data-product-id'));
        if (!data) return;
        var vid = bpwVariantId(data);
        var variant = (data.variants && data.variants[vid]) ||
                      (data.variants && data.variants[Object.keys(data.variants)[0]]);
        if (!variant) return;
        if (!window.bpSavedForLater) {
          console.warn('[bp-pdp-gallery wishlist] bpSavedForLater missing');
          return;
        }

        if (bpwIsSaved(variant.id)) {
          window.bpSavedForLater.removeWishlistItem(data.id, variant.id);
          bpwRenderAll();
          return;
        }

        var customerId = window.bpSavedForLater.getCustomerId();
        var all = window.bpSavedForLater.getSavedItemsLocalStorage() || {};
        var current = all[customerId] || { items: [], count: 0 };

        var cartItemData = {
          id: String(data.id),
          handle: data.handle,
          variant_price: String(variant.price),
          variant_compare_at_price: String(variant.compare_at_price || ''),
          variant_title: String(variant.title || ''),
          variant_id: String(variant.id),
          title: data.title,
          image: variant.image || data.image,
          quantity: '1',
          variant_sku: String(variant.sku || ''),
          savedAt: Date.now()
        };

        try {
          if (typeof window.AddToSmartWishlist === 'function') {
            window.AddToSmartWishlist(cartItemData.id, cartItemData.variant_id);
          }
        } catch (err) { console.warn('[bp-pdp-gallery wishlist] AddToSmartWishlist failed', err); }

        // Prepend (newest first) so this save shows on top of the saved drawer,
        // matching the other save paths.
        var nextItems = [cartItemData].concat(
          (current.items || []).filter(function (it) {
            return String(it.variant_id) !== String(cartItemData.variant_id);
          })
        );
        all[customerId] = Object.assign({}, current, {
          items: nextItems,
          count: nextItems.length
        });
        window.bpSavedForLater.storeSavedItemsLocalStorage(all);
        // Record the authoritative newest-first order (Swym-proof) so this save
        // stays on top regardless of Swym's sync order.
        if (typeof window.bpSavedForLater.stampSavedOrder === 'function') {
          window.bpSavedForLater.stampSavedOrder(cartItemData.variant_id);
        }
        document.dispatchEvent(new CustomEvent('wishlist:item-saved', { detail: { item: cartItemData } }));
        bpwRenderAll();
      });
    }

    /* ----- "How to Wear It" pill — smooth-scroll to the HTWI section.
       Delegated on document (registered once) rather than wired
       per-button: a color-swatch soft-swap (bp-pdp-swap) replaces
       #MainContent with a fresh gallery, and per-button listeners
       don't survive that — the delegated listener does. Falls back to
       a no-op when the widget isn't on the page (style metafield blank
       or the section toggle off). */
    if (!window.__bpHtwiScrollWired) {
      window.__bpHtwiScrollWired = true;
      document.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('[data-bp-gallery-htwi]');
        if (!btn) return;
        e.preventDefault();
        // Stylitics jump-link engagement (Atlas parity — ProductMainImages.js).
        try {
          var mod = window.styliticsComposer && window.styliticsComposer.modules && window.styliticsComposer.modules[0];
          if (mod && typeof mod.trackClickJumpLink === 'function') mod.trackClickJumpLink();
        } catch (_) {}
        var target = document.querySelector('[data-bp-stylitics-placement="pdp-how-to-wear-it"], #how-to-wear-it, .bp-htwi');
        if (!target) return;
        try {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (_) {
          target.scrollIntoView();
        }
      });
    }

    /* ----- "How to Wear It" pill — reveal only once bp-htwi confirms it
       actually has content. The pill starts [hidden] in markup (bp_style
       being set just means the section MIGHT render — Stylitics may have
       no outfits for this style, or the SDK may fail to load). Delegated +
       re-hides on every event (not just the false case) so a colour swap
       that swaps into a style with no outfits can't leave a stale visible
       pill from the previous colour up until the new result lands. */
    if (!window.__bpHtwiVisibilityWired) {
      window.__bpHtwiVisibilityWired = true;
      document.addEventListener('bp:htwi:visibility', function (e) {
        var visible = !!(e.detail && e.detail.visible);
        document.querySelectorAll('[data-bp-gallery-htwi]').forEach(function (btn) {
          btn.hidden = !visible;
        });
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bp-promo-line"] && !Shopify.designMode) return;
  try {
    // Hoist the promo span INSIDE the nearest <product-price> custom
  // element so the red copy renders to the RIGHT of the dollar
  // amount. Applies inline styles directly to <product-price> so
  // the layout takes effect regardless of `:has()` browser support
  // or CSS specificity battles with Horizon defaults.
  //
  // Idempotent. Runs at DOMContentLoaded + immediately (in case the
  // script loads late) + via MutationObserver so the hoist re-fires
  // when the quick-view drawer morphs in PDP markup.
  (function () {
    function findPriceTarget(promo) {
      // Search the closest product context (PDP main OR drawer
      // body) for the <product-price> custom element. Fall back to
      // the price container / .price span if product-price isn't
      // present.
      const root = promo.closest('product-information')
        || promo.closest('.product-information')
        || promo.closest('.bp-qd__body')
        || promo.closest('product-card')
        || promo.closest('main')
        || document;
      return root.querySelector('product-price')
        || root.querySelector('.price-container')
        || root.querySelector('.price');
    }
    function hoist(promo) {
      if (!promo || promo.dataset.bpHoisted === '1') return;
      const target = findPriceTarget(promo);
      if (!target) return;
      const tag = (target.tagName || '').toLowerCase();
      if (tag === 'product-price') {
        // product-price becomes the flex parent: price div + promo
        // span sit on the same baseline row. inline-flex didn't
        // win against Horizon's .text-block defaults — use display:
        // flex with explicit flex-direction: row and a 4px gap.
        target.appendChild(promo);
        target.dataset.bpHasPromo = '1';
        target.style.display = 'flex';
        target.style.flexDirection = 'row';
        target.style.flexWrap = 'wrap';
        target.style.alignItems = 'baseline';
        target.style.gap = '4px';
        // Promo span: defeat .text-block typography defaults that
        // were forcing margin-block-start + width:100%.
        promo.style.margin = '0';
        promo.style.width = 'auto';
      } else if (target.parentNode) {
        target.parentNode.insertBefore(promo, target.nextSibling);
      }
      promo.dataset.bpHoisted = '1';
    }
    function hoistAll(scope) {
      (scope || document).querySelectorAll('[data-bp-promo-line]:not([data-bp-hoisted="1"])').forEach(hoist);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => hoistAll());
    } else {
      hoistAll();
    }
    // Drawer morph: watch the body for newly-injected promo spans
    // and hoist them when they appear (e.g. when the quick-add
    // drawer fetches and inserts a PDP into #quick-add-modal-content).
    new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('[data-bp-promo-line]')) hoist(node);
          else if (node.querySelectorAll) hoistAll(node);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bp-require-size"] && !Shopify.designMode) return;
  try {
    class BpRequireSize extends HTMLElement {
    connectedCallback() {
      // In the quick-add drawer the content is morphed into the
      // <quick-add-dialog> shell (no .shopify-section wrapper), and the
      // buy button is redistributed into .bp-qd__cta-slot — so scope to the
      // whole dialog, which contains both the picker and the button.
      this.root = this.closest('.shopify-section') || this.closest('quick-add-dialog') || document;
      // Defer one frame so Horizon's picker + buy buttons are in the DOM.
      requestAnimationFrame(() => this.init());
    }

    disconnectedCallback() {
      // The quick-add drawer morphs this element in/out; drop the listeners +
      // observer so a detached instance doesn't keep syncing.
      if (this.onVariant) {
        ['variant:update', 'variant:change', 'variantchange'].forEach((evt) =>
          document.removeEventListener(evt, this.onVariant)
        );
      }
      if (this._mo) this._mo.disconnect();
    }

    init() {
      this.picker = this.root.querySelector('variant-picker');
      if (!this.picker) return; // single-variant product — nothing to require

      // The size radios are `required` (variant-main-picker.liquid), and the
      // buy-buttons form is NOT novalidate — so when no size is chosen the
      // browser blocks the add, Horizon's Add-to-Cart animation bails on
      // !form.checkValidity(), and each invalid radio fires an `invalid`
      // event. We catch it (capture — invalid doesn't bubble), suppress the
      // native bubble, and show our own prompt instead.
      this.root.addEventListener('invalid', (e) => this.onInvalid(e), true);

      ['change', 'input'].forEach((evt) =>
        this.picker.addEventListener(evt, () => this.sync(), { passive: true })
      );
      // Track the RESOLVED variant's stock from Horizon's variant:update
      // (e.detail.resource is the selected variant) so we can block Add to Bag
      // on a sold-out selection — the OOS size radios are only styled disabled,
      // they're still selectable, and Horizon wasn't disabling the button, so
      // the shopper could add an OOS size and only got an error on click (QA 7/21).
      this.onVariant = (e) => {
        const r = e && e.detail && (e.detail.resource || e.detail.variant);
        if (r && typeof r.available !== 'undefined') this.currentAvailable = r.available;
        this.sync();
      };
      ['variant:update', 'variant:change', 'variantchange'].forEach((evt) =>
        document.addEventListener(evt, this.onVariant)
      );

      // Re-sync on ANY change inside the picker — Horizon morphs, programmatic
      // radio checks, swatch swaps (QA: Tamara "listen to any change"). Observe
      // ONLY the picker (not the button/catcher we mutate) so there's no
      // feedback loop; coalesce a burst into one rAF pass.
      this._mo = new MutationObserver(() => {
        if (this._raf) return;
        this._raf = requestAnimationFrame(() => { this._raf = 0; this.sync(); });
      });
      const pk = this.root.querySelector('variant-picker');
      if (pk) {
        this._mo.observe(pk, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: ['checked', 'aria-checked', 'class', 'data-current-checked', 'aria-disabled', 'data-option-available'],
        });
      }

      this.sync();
    }

    fieldsets() {
      // Re-resolve the picker every read — Horizon morphs/replaces it on
      // variant change, and a cached reference would go stale (reading an old,
      // detached picker made isComplete wrong → the catcher stuck on even with
      // everything selected). QA: Tamara.
      const picker = this.root.querySelector('variant-picker');
      if (picker) this.picker = picker;
      return this.picker ? Array.from(this.picker.querySelectorAll('fieldset')) : [];
    }

    // A group only needs a choice when it offers MORE THAN ONE value. Single-
    // value groups (e.g. a one-colour option rendered as a lone/label radio)
    // have nothing to pick, so never block on them — that false-block was why a
    // fully-selected product still showed "please select your size" (Tamara).
    needsChoice(f) {
      return f.querySelectorAll('input[type="radio"]').length > 1;
    }

    // Complete = every multi-value option group has a checked radio.
    isComplete() {
      const fs = this.fieldsets();
      if (!fs.length) return true;
      return fs.every(
        (f) => !this.needsChoice(f) || f.querySelector('input[type="radio"]:checked')
      );
    }

    firstIncompleteName() {
      const fs = this.fieldsets().find(
        (f) => this.needsChoice(f) && !f.querySelector('input[type="radio"]:checked')
      );
      if (!fs) return 'size';
      const prefix = fs.querySelector('.variant-option__swatch-prefix');
      const name = prefix ? prefix.textContent.trim().toLowerCase() : '';
      return name || 'size';
    }

    onInvalid(e) {
      // Only our size radios — ignore any other required field on the page.
      if (!e.target || !this.picker.contains(e.target)) return;
      e.preventDefault(); // suppress the native "please select" bubble
      this.prompt();
    }

    prompt() {
      if (!this.picker) return;
      const msg = this.msgEl();
      msg.textContent = `Please select your ${this.firstIncompleteName()}.`;
      msg.hidden = false;
      this.picker.classList.add('bp-require-size--flag');

      const firstRadio = this.picker.querySelector(
        'fieldset input[type="radio"]:not([aria-disabled="true"])'
      );
      if (firstRadio) {
        this.picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        firstRadio.focus({ preventScroll: true });
      }
    }

    msgEl() {
      if (!this._msg) {
        this._msg = document.createElement('p');
        this._msg.className = 'bp-require-size__msg';
        this._msg.setAttribute('role', 'alert');
        this._msg.hidden = true;
        this.picker.insertAdjacentElement('afterend', this._msg);
      }
      return this._msg;
    }

    // True when a complete selection resolves to an IN-STOCK variant.
    selectionInStock() {
      // Prefer the resolved variant's availability from variant:update.
      if (this.currentAvailable === false) return false;
      if (this.currentAvailable === true) return true;
      // No variant:update yet — infer from the option radios.
      const fs = this.fieldsets();
      // No selectable option fieldsets: every option is single-value (e.g. a
      // "One Size" accessory, or a single-color necklace), so it renders as
      // static text with no radios. There's nothing to pick and no radio to
      // read — don't block; Horizon owns the single variant's sold-out state.
      // (Critical, Ernie: Color(1)+Size(1) products had Add-to-Bag stuck
      // disabled because the empty checked-list branch below returned false.)
      if (!fs.length) return true;
      // Horizon flags a sold-out value aria-disabled + data-option-available.
      const checked = fs
        .map((f) => f.querySelector('input[type="radio"]:checked'))
        .filter(Boolean);
      if (!checked.length) return false;
      return checked.every((r) =>
        r.getAttribute('aria-disabled') !== 'true' &&
        r.getAttribute('data-option-available') !== 'false'
      );
    }

    sync() {
      const complete = this.isComplete();
      const inStock = this.selectionInStock();
      const addable = complete && inStock;
      if (complete && this._msg) {
        this._msg.hidden = true;
        this.picker.classList.remove('bp-require-size--flag');
      }
      // Dynamic/accelerated checkout can't show a prompt — hide until a valid
      // in-stock selection exists.
      this.root
        .querySelectorAll('accelerated-checkout-component, .shopify-payment-button')
        .forEach((el) => {
          el.style.display = addable ? '' : 'none';
        });
      // Block Add to Bag until a size is chosen AND that variant is in stock.
      // No-size: flag via data attribute (CSS blocks pointer + dims); the
      // required-radio validity shows the BP prompt on submit, so we don't set
      // `disabled` and can't leave a dead button. OOS size chosen: the form is
      // now VALID (a size is selected), so pointer/validity no longer block a
      // keyboard submit — only `disabled` does. Set it, and track ownership so
      // we never re-enable a button Horizon/server disabled for another reason.
      this.root
        .querySelectorAll('add-to-cart-component button, button[name="add"], .add-to-cart-button')
        .forEach((btn) => {
          btn.toggleAttribute('data-bp-size-block', !addable);
          if (!addable) btn.setAttribute('aria-disabled', 'true');
          else btn.removeAttribute('aria-disabled');
          if (complete && !inStock) {
            btn.disabled = true;
            this._bpDisabled = true;
          } else if (this._bpDisabled) {
            btn.disabled = false;
            this._bpDisabled = false;
          }
          // Show the click-catcher ONLY when an option is genuinely unselected
          // (products with no options are always `complete` → never get one, so
          // they add normally). OOS-but-complete keeps its disabled/Notify-Me
          // state with no catcher.
          this.setCatcher(btn, !complete);
        });
    }

    // Lay a transparent catcher over the greyed (inert) Add-to-Bag so a tap
    // shows the prompt without the click ever reaching Horizon's button — no
    // add, no animation. Toggled per sync; rebuilt if a variant morph replaced
    // the button.
    setCatcher(btn, on) {
      const host = btn.parentElement;
      if (!host) return;
      if (on) {
        host.classList.add('bp-require-size__host');
        let ov = host.querySelector(':scope > .bp-require-size__catch');
        if (!ov) {
          // A DIV, not a <button> — a button would match the PDP's
          // `add-to-cart-component button` rules (bag-icon ::after + button
          // states) and paint over the real CTA. The div is an invisible
          // click-catcher only; keyboard submit is handled by the real button
          // (→ onInvalid), so it needs no focus/role.
          ov = document.createElement('div');
          ov.className = 'bp-require-size__catch';
          ov.setAttribute('aria-hidden', 'true');
          ov.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.prompt();
          });
          host.appendChild(ov);
        }
        ov.hidden = false;
      } else {
        const ov = host.querySelector(':scope > .bp-require-size__catch');
        if (ov) ov.hidden = true;
      }
    }
  }

  if (!customElements.get('bp-require-size')) {
    customElements.define('bp-require-size', BpRequireSize);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bp-youll-also-love"] && !Shopify.designMode) return;
  try {
    const BP_YALL_BR_WIDGET = '09z4d58l';
  const BP_YALL_BR_HOST   = 'https://pathways.dxpapi.com/api/v2/widgets/item/';
  const BP_YALL_BR_FIELDS = 'pid,title,url,brand,price,sale_price,thumb_image,sku,slug';

  class BpYall extends HTMLElement {
    async connectedCallback() {
      this.productId = this.dataset.bpYallProductId;
      this.limit = parseInt(this.dataset.bpYallLimit, 10) || 20;
      this.recsUrl = this.dataset.bpYallRecsUrl || '/recommendations/products';
      this.amplience = this.dataset.bpYallAmplience || '';
      this.useBr = this.dataset.bpYallUseBr === 'true';
      this.rail = this.querySelector('[data-bp-yall-rail]');
      this.prev = this.querySelector('[data-bp-yall-prev]');
      this.next = this.querySelector('[data-bp-yall-next]');

      if (!this.productId || !this.rail) {
        console.warn('[bp-yall] missing productId or rail', { productId: this.productId, rail: !!this.rail });
        return;
      }

      try {
        const products = this.useBr
          ? await this.fetchBloomreach()
          : await this.fetchRecommendations();
        if (!products || !products.length) {
          this.hidden = true;
          return;
        }
        this.render(products.slice(0, this.limit));
        this.wireArrows();
        this.updateArrowState();
        if (this.useBr) this.handOffToHydrate();
      } catch (err) {
        console.warn('[bp-yall] fetch failed', err);
        this.hidden = true;
      }
    }

    // BR's item widget doesn't return sibling-color data, so swatches
    // are hydrated the same way the PLP does it: assets/bp-card-hydrate.js
    // reads each card's data-product-url and fetches
    // /products/<handle>?view=hydrate for the sibling list. That script
    // loads deferred (see the conditional script tag in the block markup),
    // so poll briefly in case this fetch resolves first.
    handOffToHydrate() {
      const rail = this.rail;
      const tick = (left) => {
        if (window.BpCardHydrate && typeof window.BpCardHydrate.observeCards === 'function') {
          window.BpCardHydrate.observeCards(rail);
          return;
        }
        if (left <= 0) return;
        setTimeout(() => tick(left - 100), 100);
      };
      tick(3000);
    }

    async fetchBloomreach() {
      const br = (window.shop && window.shop.br) || {};
      const accountId = br.accountId || '';
      const domainKey = br.domainKey || 'bostonproper';
      const uidMatch  = document.cookie.match(/(?:^|;\s*)_br_uid_2=([^;]+)/);
      // Send the real BR cookie value, DECODED so the URLSearchParams encoding
      // below single-encodes it (the cookie is stored URL-encoded; passing it
      // raw double-encodes → uid%253D…, the BR audit finding). Absent cookie →
      // empty string, and the param is stripped below so the call is anonymous.
      // NEVER fabricate uid=0:v=app:ts=0:hc=1 — BR flags that sentinel as an
      // invalid _br_uid_2 (pollutes personalization/reporting). Matches every
      // other BR builder (bp-bloomreach.js, bp-bloomreach-carousel.js,
      // bp-badges.js, window.bpBr.uid).
      let uid = '';
      if (uidMatch) { try { uid = decodeURIComponent(uidMatch[1]); } catch (_) { uid = uidMatch[1]; } }

      const params = new URLSearchParams({
        account_id:  accountId,
        domain_key:  domainKey,
        item_ids:    this.productId,
        rows:        String(this.limit),
        fields:      BP_YALL_BR_FIELDS,
        _br_uid_2:   uid,
        url:         window.location.href,
        ref_url:     document.referrer || window.location.href,
      });
      if (!params.get('_br_uid_2')) params.delete('_br_uid_2');

      const res = await fetch(`${BP_YALL_BR_HOST}${BP_YALL_BR_WIDGET}?${params}`, { credentials: 'omit' });
      if (!res.ok) throw new Error('BR HTTP ' + res.status);
      const data = await res.json();
      const docs = (data.response && data.response.docs) || [];

      // Normalize BR's absolute URL to a same-origin `/products/<handle>`
      // path — BR staging emits `staging.example.com`, prod may emit
      // `www.bostonproper.com`. Relative paths always resolve to the
      // current shop origin (staging.bostonproper.com or bostonproper.com).
      const hrefFromDoc = (doc) => {
        const m = String(doc.url || '').match(/\/products\/([^/?#]+)/);
        return m ? `/products/${m[1]}` : (doc.url || '');
      };
      return docs.map((doc) => {
        const onSale = doc.sale_price != null && doc.price != null && Number(doc.sale_price) < Number(doc.price) - 0.001;
        return {
          title:           doc.title || '',
          url:             hrefFromDoc(doc),
          image:           doc.thumb_image || '',
          price:           onSale ? doc.sale_price : doc.price,
          compare_at_price: onSale ? doc.price : null,
        };
      });
    }

    async fetchRecommendations() {
      // Try the JSON endpoint FIRST — most reliable across themes
      // because it doesn't depend on a sections/product-recommendations
      // template existing in the theme. Shape:
      //   { products: [{ id, handle, title, url, featured_image, … }] }
      const jsonUrl = `${this.recsUrl}.json?product_id=${this.productId}&limit=${this.limit}&intent=related`;
      try {
        const jsonRes = await fetch(jsonUrl, { credentials: 'same-origin' });
        if (jsonRes.ok) {
          const data = await jsonRes.json();
          if (data && Array.isArray(data.products) && data.products.length) {
            return data.products;
          }
        }
      } catch (_) {
        // Fall through to section-render fallback.
      }

      // Fallback: section-render endpoint (HTML response).
      const params = new URLSearchParams({
        section_id: 'product-recommendations',
        product_id: this.productId,
        intent: 'related',
        limit: String(this.limit),
      });
      const url = `${this.recsUrl}?${params.toString()}`;
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('recs HTTP ' + res.status);
      const text = await res.text();
      // Try JSON-decoding (some themes register the section as JSON)
      // before falling back to HTML parsing.
      try {
        const data = JSON.parse(text);
        return data.products || [];
      } catch (_) {
        return this.parseHtmlResponse(text);
      }
    }

    parseHtmlResponse(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      // Grab every product link with a product handle in the href.
      const links = doc.querySelectorAll('a[href*="/products/"]');
      const seen = new Set();
      const out = [];
      links.forEach((a) => {
        const href = a.getAttribute('href') || '';
        const handle = href.split('/products/')[1]?.split(/[\/?#]/)[0];
        if (!handle || seen.has(handle)) return;
        seen.add(handle);
        const img = a.querySelector('img');
        const title = (img && (img.getAttribute('alt') || img.alt))
          || (a.querySelector('.product-recommendations__title')?.textContent)
          || handle.replace(/-/g, ' ');
        const styleEl = a.closest('[data-style]');
        const style = styleEl ? styleEl.getAttribute('data-style') : '';
        const srcsetSrc = img && (img.getAttribute('src') || img.getAttribute('data-src'));
        out.push({
          handle,
          url: href,
          title: title.trim(),
          style,
          image: srcsetSrc || '',
        });
      });
      return out;
    }

    render(products) {
      const html = products.map((p) => {
        const handle = p.handle || (p.url && p.url.split('/products/')[1]?.split(/[\/?#]/)[0]) || '';
        const url = p.url || (handle ? `/products/${handle}` : '#');
        const title = (p.title || handle || 'Product').replace(/-/g, ' ');
        // Prefer Amplience SET image keyed off bp_style. Fall back to
        // the featured image if no style or amplience base.
        let image = '';
        const style = p.style || (p.metafields && p.metafields.BP_ProductAttributes && p.metafields.BP_ProductAttributes.bp_style);
        if (style && this.amplience) {
          image = `${this.amplience}/s/bostonproper/${style}_SET?w=480`;
        } else if (p.featured_image && (p.featured_image.src || typeof p.featured_image === 'string')) {
          image = (p.featured_image.src || p.featured_image) + '';
        } else if (p.image) {
          image = p.image;
        } else if (Array.isArray(p.images) && p.images[0]) {
          image = p.images[0].src || p.images[0];
        }
        return `
          <li class="bp-yall__item bp-card" data-product-url="${url}">
            <a class="bp-yall__link" href="${url}" data-bp-card-product-link>
              <div class="bp-yall__media">
                <img src="${image}" alt="${this.escape(title)}" loading="lazy" width="320" height="400" data-bp-card-image-primary>
              </div>
            </a>
            <div class="bp-card__body">
              <p class="bp-yall__title"><a href="${url}" data-bp-card-product-link>${this.escape(title)}</a></p>
            </div>
          </li>`;
      }).join('');
      this.rail.innerHTML = html;
    }

    escape(s) {
      return String(s || '').replace(/[&<>"']/g, (c) => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
      }[c]));
    }

    wireArrows() {
      if (this.prev) {
        this.prev.addEventListener('click', () => {
          this.rail.scrollBy({ left: -this.rail.clientWidth * 0.9, behavior: 'smooth' });
        });
      }
      if (this.next) {
        this.next.addEventListener('click', () => {
          this.rail.scrollBy({ left: this.rail.clientWidth * 0.9, behavior: 'smooth' });
        });
      }
      this.rail.addEventListener('scroll', () => this.updateArrowState(), { passive: true });
    }

    updateArrowState() {
      const max = this.rail.scrollWidth - this.rail.clientWidth;
      if (this.prev) this.prev.toggleAttribute('disabled', this.rail.scrollLeft <= 1);
      if (this.next) this.next.toggleAttribute('disabled', this.rail.scrollLeft >= max - 1);
    }
  }
  if (!customElements.get('bp-yall')) customElements.define('bp-yall', BpYall);
  } catch(e) { console.error(e); }
})();

})();
